(function($) {
  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Main Script
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/
  $(function() {
    /* ----------------------------------------------------------------
    Global Variable declarations
    -----------------------------------------------------------------*/
    // Setting Up Global Variables to be used in JS - Denotes which template is which so JavaScript is used only on proper templates
    var BODY = $('body'),
      SCROLL_TO_TOP_BUTTON = $('.scroll-to-top'),
      mmStatus = 'closed'; // Mobile Navigation

    /* ----------------------------------------------------------------
    Homepage transparent header
    -----------------------------------------------------------------*/
    var TRANS_HEADER_CLASS = 'transparent-header',
      toggleHeaderTransparency = function () {
        if (mmStatus === 'opened') { return; }

        var header = $('.header');
        var searchOpen = $('.header__searchForm--show');

        if (window.pageYOffset < header.height() * 2) {
          if( searchOpen.length <= 0) {
            header.addClass(TRANS_HEADER_CLASS);
          }
        } else {
          header.removeClass(TRANS_HEADER_CLASS);
        }
      };

      if (BODY.hasClass('page-regenerative-template') || window.location.href.includes('/fw22-lp')) {
        if (!$('.heroModules').length) {
          toggleHeaderTransparency();
          $(window).scroll($.throttle(250, toggleHeaderTransparency));
        }
      }


    /* ----------------------------------------------------------------
    Footer mobile accordian
    -----------------------------------------------------------------*/
    $('.footer__top .mobile-accordian h3').on('click', function (e) {
      if (parseInt($(window).width()) <= 960) { // NOTE: the same width as 60em breakpoint is CSS for mobile layout
        var OPEN_CLASS = 'accordian-open',
          target = $(this),
          parent = target.parents('.mobile-accordian');

          e.preventDefault();

          parent.toggleClass(OPEN_CLASS);
          target.siblings().slideToggle(200);
          parent.find('.triangle').toggleClass('down');
      }
    });

    /* ----------------------------------------------------------------
    Footer call link (on desktop show number, don't use tel link)
    -----------------------------------------------------------------*/
    $('#call-link').on('click', function (e) {
      if (parseInt($(window).width()) > 960) { // NOTE: the same width as 60em breakpoint is CSS for mobile layout
        e.preventDefault();

        $(this).siblings('.phone-number').toggle();
      }
    });

    /* ----------------------------------------------------------------
    Multiple Promo messages (endless loop showing them all)
    -----------------------------------------------------------------*/
    function checkLocationForPromo (should_double_check) {
      var vt_info = localStorage.getItem('_vt_info'); // NOTE: piggyback off cybba app that already geo locates

      if (!vt_info && should_double_check) {
        setTimeout(function () {
          checkLocationForPromo(false);
        }, 5000);
      } else {
        vt_info = JSON.parse(vt_info);

          var PROMO_DELAY = 6000,
            PROMO_FADE = 750,
            PROMO_MESSAGES = $('.header-utility-promo'),
            PROMO_LEN = PROMO_MESSAGES.length,
            current_promo_indx = 0,
            showNextPromo = function () {
              current_promo_indx++;

              if (current_promo_indx >= PROMO_LEN) { current_promo_indx = 0; }

              PROMO_MESSAGES.eq(current_promo_indx).fadeIn(PROMO_FADE)
              .delay(PROMO_DELAY)
              .fadeOut(PROMO_FADE, showNextPromo);
            };

          if (PROMO_LEN) {
            if (PROMO_LEN > 1) {
              PROMO_MESSAGES.eq(0).delay(PROMO_DELAY).fadeOut(PROMO_FADE, showNextPromo);
            }
          } else {
            // NOTE: hide the util header in the rare case that promo messages exist but none of them are enabled
            $('.header-utility').hide();
          }
      }
    }

    // NOTE: runs on page load, and internally it will check again if it failed to find info
    checkLocationForPromo(true);





    /* ----------------------------------------------------------------
    DataLayer Tracking
    -----------------------------------------------------------------*/
    $('.btn--checkout').on('click', function(e) {
      e.preventDefault();

      var productIDs = [];
      var productTypes = [];
      var products = $('.minicart-line-item');

      products.each(function(i, product) {
        productIDs.push($(product).data('popupId'));

        if ($(product).find('.productPopUp__productVariant').html()) {
          productTypes.push($(product).find('.productPopUp__productVariant').html().replace('Size:', ''));
        }
      });

      dataLayer.push({
        event: 'Checkout Initiated',
        productID: productIDs,
        productCategory: productTypes
      });

      location.href = '/checkout';
    });

    /* ----------------------------------------------------------------
    PRODUCT - Recommended Product Feature
    -----------------------------------------------------------------*/
    function displayRecommendedProducts (products) {
      products.forEach(function(product) {
        var product_loop_template = $('#related-product__template').html();
        var compiled_html = _.template(product_loop_template, product);
        $('.section--related-products .products').append(compiled_html({product: product}));
        if (REBASE && REBASE.lists) {
          REBASE.lists.updateActiveProductVariant({
            product_id: product.id,
            variant_id: product.variants[0].id
          });
        }
      });
    }

    function getRecommendedProducts (id) {
      $.getJSON('/recommendations/products.json?product_id=' + id + '&limit=4', function (resp) {
        if (resp.products && resp.products.length) {
          displayRecommendedProducts(resp.products);
        } else {
          $('.section--related-products').hide();
        }
      });
    }

    if ($('body').hasClass('product-template')) {
      if (typeof rehash_related_products !== 'undefined' && rehash_related_products.length > 0) {
        displayRecommendedProducts(rehash_related_products);
      } else {
        var rec_product_json;
        if (document.getElementById('product__json')) {
          rec_product_json = JSON.parse(document.getElementById('product__json').innerHTML);
          getRecommendedProducts(rec_product_json.id);
        } else {
          rec_product_json = JSON.parse(document.getElementById('cart-item__json').innerHTML);
          getRecommendedProducts(rec_product_json.product_id);
        }
      }
    }

    /* ----------------------------------------------------------------
    Collection description read more
    -----------------------------------------------------------------*/
    if ($('body').hasClass('collection-alternate-template')) {
      // console.warn('ALTERNATE');
      var collection_desc_wrap = $('#collection-title-description'),
        desc = $('.collection-description-content', collection_desc_wrap),
        SMALL_HEIGHT = 68,
        BUFFER = 8,
        read_more_toggle;

      if (desc.height() > SMALL_HEIGHT - BUFFER) {
        read_more_toggle = $('<a href="#" class="read-more-toggle">Read more</a>');
        read_more_toggle.on('click', function (e) {
          e.preventDefault();
          var SHOWING_CLASS = 'read-more-showing',
            target = $(e.target),
            parent = target.parent('#collection-title-description');

          if (parent.hasClass(SHOWING_CLASS)) {
            target.text('Read more');
            desc.animate({'height': SMALL_HEIGHT}, 300);
            parent.removeClass(SHOWING_CLASS);
          } else {
            target.text('Read less');
            desc.animate({
              height: desc.get(0).scrollHeight
            }, 300, function(){
              $(this).height('auto');
            });
            parent.addClass(SHOWING_CLASS);
          }
        });

        // hide tall content and append link
        desc.css({'height': SMALL_HEIGHT});
        collection_desc_wrap.append(read_more_toggle);
      }
    }


    /* ----------------------------------------------------------------
    jQuery toggles
    -----------------------------------------------------------------*/
    //collection grid size toggle
    $(document).on('click', '.grid-size-toggle', function(e) {
      var _this = $(this);
      if ( _this.hasClass('grid-size-toggle--selected') ) { return; }

      _this.addClass('grid-size-toggle--selected').siblings().removeClass('grid-size-toggle--selected');
      $('.products .product, .products .grid-promo').removeClass('column--xs-12 column--xs-6').addClass('column--xs-' + _this.data('size'));
    });

    //Press Section
    $('.press-view-more').on('click', function(e) {
      e.preventDefault();
      $(this).prev().toggle();
      if ($(this).hasClass('view-more')) {
        $(this).toggleClass('view-more', 'view-less').html('<i class="fa fa-minus-square" aria-hidden="true"></i> View Less');
      } else {
        $(this).toggleClass('view-more', 'view-less').html('<i class="fa fa-plus-square" aria-hidden="true"></i> View More');
      }
    });

    // FAQ
    if ($('body').is('#faq-frequently-id')) {

      // Open link on page load
      $('.faq-group--title').each(function (ele) {
        var OPEN_CLASS = 'group-open',
          hash = location.hash,
          target = $(this),
          parent = target.parents('.faq-group');

        if (target.is(hash)) {
          parent.toggleClass(OPEN_CLASS);
          target.siblings('.faq-group--questions').slideToggle(200);
          target.find('.triangle').toggleClass('down');
        }
      });


      // $('.faq-group--title').on('click', function (e) {
      //   debugger;
      //   var OPEN_CLASS = 'group-open',
      //       target = $(this),
      //       parent = target.parents('.faq-group');

      //   e.preventDefault();

      //   parent.add(OPEN_CLASS);
      //   target.siblings('.faq-group--questions').slideToggle(200);
      //   target.find('.triangle').add('down');
      // });


      // $('.faq-question h4').on('click', function (e) {
      //   var OPEN_CLASS = 'question-open',
      //       target = $(this),
      //       parent = target.parents('.faq-question');

      //   e.preventDefault();

      //   parent.toggleClass(OPEN_CLASS);
      //   target.siblings('.faq-answer').slideToggle(200);
      // });
    }

    //SUSTAINABILITY
    if ($('body').is('#sustainability-id')) {

      $('.filtering-group > p').on('click', function () {
        $(this).parent().toggleClass('collapsed');
        $(this).children('.triangle').toggleClass('down')
      });
    }

    //Login Page - forgot password toggle
    $('#forgot-password').on('click', function() {
      $('#recover-password-form').show();
      $('#customer-login-form').hide();
    });

    $('#forgot-password-cancel').on('click', function() {
      $('#recover-password-form').hide();
      $('#customer-login-form').show();
    });

    //Article share toggle
    $('#article-share-link').on('click', function(e) {
      e.preventDefault();
      $(this)
        .next()
        .toggle();
      if ($(this).text() == '+ Share') {
        $(this).text('- Share');
      } else {
        $(this).text('+ Share');
      }
    });

    function rb__debounce(func, wait, immediate) {
      var timeout;

      return function executedFunction() {
        var context = this;
        var args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    var returnedFunction = rb__debounce(function(e) {
      if (window.pageYOffset > 600) {
        SCROLL_TO_TOP_BUTTON.addClass('scroll-to-top--visible');
      } else {
        SCROLL_TO_TOP_BUTTON.removeClass('scroll-to-top--visible');
      }
    }, 200);

    if (SCROLL_TO_TOP_BUTTON.length) {
      window.addEventListener('scroll', returnedFunction);

      SCROLL_TO_TOP_BUTTON.on('click', function(e) {
        e.preventDefault();
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    /* ----------------------------------------------------------------
    New User email signup Modal
    -----------------------------------------------------------------*/
    if (localStorage.getItem('returnUser') == undefined) {
      localStorage.setItem('returnUser', true);
    }
  });
})(jQuery);
